import { Pipe, PipeTransform } from '@angular/core';
import type { Section } from '../../../models/menu/section/section';

@Pipe({
  name: 'sectionBasicMethod',
  standalone: false
})
export class SectionBasicMethodPipe implements PipeTransform {
  /**
   * @deprecated use MethodPipe instead
   */
  transform(section: Section, methodKey: string, argument?: any): any {
    return section?.[methodKey]?.(argument);
  }
}
